import axios from 'axios';

import {
  openSuccessPopup,
  openErrorPopup,
  openPopup,
  closePopup,
} from 'containers/App/actions';

import {
  FETCH_MASTER_ACCOUNTS,
  FETCH_MASTER_ACCOUNTS_SUCCESS,
  FETCH_MASTER_ACCOUNTS_ERROR,
  CHECK_MASTER_ACCOUNTS_PROHIBITION,
  CHECK_MASTER_ACCOUNTS_PROHIBITION_SUCCESS,
  CHECK_MASTER_ACCOUNTS_PROHIBITION_ERROR,
  UPDATE_MASTER_ACCOUNTS_PROHIBITION,
  UPDATE_MASTER_ACCOUNTS_PROHIBITION_SUCCESS,
  UPDATE_MASTER_ACCOUNTS_PROHIBITION_ERROR,
  FETCH_ASSOCIATED_ACCOUNTS,
  FETCH_ASSOCIATED_ACCOUNTS_SUCCESS,
  FETCH_ASSOCIATED_ACCOUNTS_ERROR,
  CREATE_ACCOUNT_LINK,
  CREATE_ACCOUNT_LINK_SUCCESS,
  CREATE_ACCOUNT_LINK_ERROR,
  REQUESTS_TYPES,
  REQUESTS_DURATIONS,
  RESET_ACCOUNT_LINKING_STATUS,
  DELETE_ACCOUNT_LINK,
  DELETE_ACCOUNT_LINK_SUCCESS,
  DELETE_ACCOUNT_LINK_ERROR,
  DELETE_MASTER_ACCOUNT_LINK,
  DELETE_MASTER_ACCOUNT_LINK_SUCCESS,
  DELETE_MASTER_ACCOUNT_LINK_ERROR,
  SEND_ACCOUNT_LINK_REQUEST_SUCCESS,
  CANCEL_LINKAGE_REQUEST,
  CANCEL_LINKAGE_REQUEST_SUCCESS,
  CANCEL_LINKAGE_REQUEST_ERROR,
  FETCH_LINKAGE_REQUESTS,
  FETCH_LINKAGE_REQUESTS_SUCCESS,
  FETCH_LINKAGE_REQUESTS_ERROR,
  FETCH_LINKAGE_REQUESTS_FOR_MASTER,
  FETCH_LINKAGE_REQUESTS_FOR_MASTER_SUCCESS,
  FETCH_LINKAGE_REQUESTS_FOR_MASTER_ERROR,
  CANCEL_LINKAGE_REQUEST_FOR_MASTER_SUCCESS,
  CANCEL_LINKAGE_REQUEST_FOR_MASTER,
  UPDATE_LINKAGE_REQUEST,
  UPDATE_LINKAGE_REQUEST_SUCCESS,
  UPDATE_LINKAGE_REQUEST_ERROR,
  UPDATE_LINKAGE_REQUEST_FOR_MASTER,
  UPDATE_LINKAGE_REQUEST_FOR_MASTER_SUCCESS,
  FETCH_OFFER,
  FETCH_OFFER_SUCCESS,
  FETCH_OFFER_ERROR,
  TOGGLE_OFFER_POPUP,
  FETCH_LOGIN_USER_TYPES,
  FETCH_LOGIN_USER_TYPES_SUCCESS,
  FETCH_LOGIN_USER_TYPES_ERROR,
  RESET_LOGIN_USER_TYPES,
  AMBIGUOUS_USER_TYPE_ERROR,
  OFFER_TYPE,
  UPDATE_ASSOCIATED_ACCOUNT,
  UPDATE_ASSOCIATED_ACCOUNT_ERROR,
  UPDATE_ASSOCIATED_CTN_ACCOUNT_SUCCESS,
  UPDATE_ASSOCIATED_BAN_ACCOUNT_SUCCESS,
  UPDATE_ASSOCIATED_BEN_ACCOUNT_SUCCESS,
  RESET_ASSOCIATED_ACCOUNTS_ERROR,
  RESET_MASTER_ACCOUNTS_ERROR,
  ACCOUNT_EDIT_POPUP_KEY,
  ACCOUNT_GROUP_EDIT_POPUP_KEY,
  CONTRACT_EDIT_POPUP_KEY,
  ASSOCIATE_ACCOUNT_POPUP_KEY,
  ASSOCIATE_MASTER_ACCOUNT_POPUP_KEY,
  CONFIRMATION_DELETING_POPUP_KEY,
  CONFIRMATION_MASTER_DELETING_POPUP_KEY,
  FETCH_PIN_PUK,
  FETCH_PIN_PUK_SUCCESS,
  FETCH_PIN_PUK_ERROR,
} from './constants';

const formatLogin = (input) => {
  const escapedString = input.replace(/[^\w]/ig, '');
  const firstChar = escapedString.charAt(0);

  if (escapedString.match(/\d{11}/) && (firstChar === '7' || firstChar === '8')) {
    return escapedString.substr(1);
  }

  return input;
};

const getLinkageRequests = (type, destination) => axios.get('/api/profile/settings/sso/linkagerequests/', {
  params: {
    requestType: type,
    requestDestination: destination,
  },
});

const updateCtnAccount = (data) => axios.post('/api/profile/settings/sso/associatedctnaccount/', data);

export { updateMasterNickName } from 'containers/App/actions';

export function fetchMasterAccountsStart() {
  return {
    type: FETCH_MASTER_ACCOUNTS,
  };
}

export function fetchMasterAccountsSuccess(data) {
  return {
    data,
    type: FETCH_MASTER_ACCOUNTS_SUCCESS,
  };
}

export function fetchMasterAccountsError(error) {
  return {
    error,
    type: FETCH_MASTER_ACCOUNTS_ERROR,
  };
}

export function fetchPinPukStart() {
  return {
    type: FETCH_PIN_PUK,
  };
}

export function fetchPinPukSuccess(data) {
  return {
    data,
    type: FETCH_PIN_PUK_SUCCESS,
  };
}

export function fetchPinPukError(error) {
  return {
    error,
    type: FETCH_PIN_PUK_ERROR,
  };
}

export function checkMasterAccountsProhibitionStart() {
  return {
    type: CHECK_MASTER_ACCOUNTS_PROHIBITION,
  };
}

export function checkMasterAccountsProhibitionSuccess(data) {
  return {
    data,
    type: CHECK_MASTER_ACCOUNTS_PROHIBITION_SUCCESS,
  };
}

export function checkMasterAccountsProhibitionError(error) {
  return {
    error,
    type: CHECK_MASTER_ACCOUNTS_PROHIBITION_ERROR,
  };
}

export function updateMasterAccountsProhibitionStart() {
  return {
    type: UPDATE_MASTER_ACCOUNTS_PROHIBITION,
  };
}

export function updateMasterAccountsProhibitionSuccess(data) {
  return {
    data,
    type: UPDATE_MASTER_ACCOUNTS_PROHIBITION_SUCCESS,
  };
}

export function handleUpdatingMasterAccountsProhibitionError(error) {
  return {
    error,
    type: UPDATE_MASTER_ACCOUNTS_PROHIBITION_ERROR,
  };
}

export function updateMasterAccountsProhibitionError(error) {
  return (dispatch) => {
    dispatch(handleUpdatingMasterAccountsProhibitionError(error));
    dispatch(openErrorPopup());
  };
}

export function fetchAssociatedAccountsStart() {
  return {
    type: FETCH_ASSOCIATED_ACCOUNTS,
  };
}

export function fetchAssociatedAccountsSuccess(data) {
  return {
    data,
    type: FETCH_ASSOCIATED_ACCOUNTS_SUCCESS,
  };
}

export function fetchAssociatedAccountsError(error) {
  return {
    error,
    type: FETCH_ASSOCIATED_ACCOUNTS_ERROR,
  };
}

export function createAccountLinkStart() {
  return {
    type: CREATE_ACCOUNT_LINK,
  };
}

export function createAccountLinkSuccess() {
  return {
    type: CREATE_ACCOUNT_LINK_SUCCESS,
  };
}

export function createAccountLinkError(error) {
  return {
    error,
    type: CREATE_ACCOUNT_LINK_ERROR,
  };
}

export function cancelLinkageRequestStart(login) {
  return {
    data: login,
    type: CANCEL_LINKAGE_REQUEST,
  };
}

export function cancelLinkageRequestForMasterStart(login) {
  return {
    data: login,
    type: CANCEL_LINKAGE_REQUEST_FOR_MASTER,
  };
}

export function cancelLinkageRequestSuccess(login) {
  return {
    data: login,
    type: CANCEL_LINKAGE_REQUEST_SUCCESS,
  };
}

export function cancelLinkageRequestForMasterSuccess(login) {
  return {
    data: login,
    type: CANCEL_LINKAGE_REQUEST_FOR_MASTER_SUCCESS,
  };
}

export function handleCancelingLinkageRequestError(error) {
  return {
    error,
    type: CANCEL_LINKAGE_REQUEST_ERROR,
  };
}

export function cancelLinkageRequestError(error) {
  return (dispatch) => {
    dispatch(handleCancelingLinkageRequestError(error));
    dispatch(openErrorPopup());
  };
}

export function toggleOfferPopup(isOpened) {
  return {
    data: isOpened,
    type: TOGGLE_OFFER_POPUP,
  };
}

export function resetAccountLinkingStatus() {
  return {
    type: RESET_ACCOUNT_LINKING_STATUS,
  };
}

export function deleteAccountLinkStart() {
  return {
    type: DELETE_ACCOUNT_LINK,
  };
}

export function handleDeletingAccountLinkSuccess(login) {
  return {
    data: login,
    type: DELETE_ACCOUNT_LINK_SUCCESS,
  };
}

export function deleteAccountLinkSuccess(login) {
  return (dispatch) => {
    dispatch(handleDeletingAccountLinkSuccess(login));
    dispatch(openSuccessPopup({
      message: 'settings.numberManagement.accessIsCanceled',
      vars: { login },
      messageAsTranslationKey: true,
      keepPreviousPopupOpened: false,
    }));
  };
}

export function handleDeletingAccountLinkError(error) {
  return {
    error,
    type: DELETE_ACCOUNT_LINK_ERROR,
  };
}

export function deleteAccountLinkError(error) {
  return (dispatch) => {
    dispatch(handleDeletingAccountLinkError(error));
    dispatch(openErrorPopup({
      keepPreviousPopupOpened: false,
    }));
  };
}

export function deleteMasterAccountLinkStart() {
  return {
    type: DELETE_MASTER_ACCOUNT_LINK,
  };
}

export function handleDeletingMasterAccountLinkSuccess(login) {
  return {
    data: login,
    type: DELETE_MASTER_ACCOUNT_LINK_SUCCESS,
  };
}

export function deleteMasterAccountLinkSuccess(login) {
  return (dispatch) => {
    dispatch(handleDeletingMasterAccountLinkSuccess(login));
    dispatch(openSuccessPopup({
      message: 'settings.numberManagement.masterAccessIsCanceled',
      vars: { login },
      messageAsTranslationKey: true,
      keepPreviousPopupOpened: false,
    }));
  };
}

export function handleDeletingMasterAccountLinkError(error) {
  return {
    error,
    type: DELETE_MASTER_ACCOUNT_LINK_ERROR,
  };
}

export function deleteMasterAccountLinkError(error) {
  return (dispatch) => {
    dispatch(handleDeletingMasterAccountLinkError(error));
    dispatch(openErrorPopup({
      keepPreviousPopupOpened: false,
    }));
  };
}

export function sendAccountLinkRequestSuccess() {
  return {
    type: SEND_ACCOUNT_LINK_REQUEST_SUCCESS,
  };
}

export function fetchLinkageRequestsStart() {
  return {
    type: FETCH_LINKAGE_REQUESTS,
  };
}

export function fetchLinkageRequestsSuccess(data) {
  return {
    data,
    type: FETCH_LINKAGE_REQUESTS_SUCCESS,
  };
}

export function fetchLinkageRequestsError(error) {
  return {
    error,
    type: FETCH_LINKAGE_REQUESTS_ERROR,
  };
}

export function fetchLinkageRequestsForMasterStart() {
  return {
    type: FETCH_LINKAGE_REQUESTS_FOR_MASTER,
  };
}

export function fetchLinkageRequestsForMasterSuccess(data) {
  return {
    data,
    type: FETCH_LINKAGE_REQUESTS_FOR_MASTER_SUCCESS,
  };
}

export function fetchLinkageRequestsForMasterError(error) {
  return {
    error,
    type: FETCH_LINKAGE_REQUESTS_FOR_MASTER_ERROR,
  };
}

export function updateLinkageRequestStart(login) {
  return {
    data: login,
    type: UPDATE_LINKAGE_REQUEST,
  };
}

export function updateLinkageRequestSuccess(login) {
  return {
    data: login,
    type: UPDATE_LINKAGE_REQUEST_SUCCESS,
  };
}

export function handleUpdatingLinkageRequestError(error) {
  return {
    error,
    type: UPDATE_LINKAGE_REQUEST_ERROR,
  };
}

export function updateLinkageRequestError(error) {
  return (dispatch) => {
    dispatch(handleUpdatingLinkageRequestError(error));
    dispatch(openErrorPopup());
  };
}

export function updateLinkageRequestForMasterStart(login) {
  return {
    data: login,
    type: UPDATE_LINKAGE_REQUEST_FOR_MASTER,
  };
}

export function updateLinkageRequestForMasterSuccess(login) {
  return {
    data: login,
    type: UPDATE_LINKAGE_REQUEST_FOR_MASTER_SUCCESS,
  };
}

export function fetchOfferStart() {
  return {
    type: FETCH_OFFER,
  };
}

export function fetchOfferSuccess(data) {
  return {
    data,
    type: FETCH_OFFER_SUCCESS,
  };
}

export function fetchOfferError(error) {
  return {
    error,
    type: FETCH_OFFER_ERROR,
  };
}

export function fetchLoginUserTypesStart() {
  return {
    type: FETCH_LOGIN_USER_TYPES,
  };
}

export function fetchLoginUserTypesSuccess(data) {
  return {
    data,
    type: FETCH_LOGIN_USER_TYPES_SUCCESS,
  };
}

export function handleFetchingLoginUserTypesError(error) {
  return {
    error,
    type: FETCH_LOGIN_USER_TYPES_ERROR,
  };
}

export function fetchLoginUserTypesError(error) {
  return (dispatch) => {
    dispatch(handleFetchingLoginUserTypesError(error));
    dispatch(openErrorPopup());
  };
}

export function resetLoginUserTypes() {
  return {
    type: RESET_LOGIN_USER_TYPES,
  };
}

export function resetAssociatedAccountsError() {
  return {
    type: RESET_ASSOCIATED_ACCOUNTS_ERROR,
  };
}

export function resetMasterAccountsError() {
  return {
    type: RESET_MASTER_ACCOUNTS_ERROR,
  };
}

export function updateAssociatedAccountStart() {
  return {
    type: UPDATE_ASSOCIATED_ACCOUNT,
  };
}

export function handleUpdatingAssociatedAccountError(error) {
  return {
    error,
    type: UPDATE_ASSOCIATED_ACCOUNT_ERROR,
  };
}

export function updateAssociatedAccountError(error) {
  return (dispatch) => {
    dispatch(handleUpdatingAssociatedAccountError(error));
    dispatch(openErrorPopup());
  };
}

export function handleUpdatingAssociatedCtnAccountSuccess(data) {
  return {
    data,
    type: UPDATE_ASSOCIATED_CTN_ACCOUNT_SUCCESS,
  };
}

export function updateAssociatedCtnAccountSuccess(data) {
  return (dispatch) => {
    dispatch(handleUpdatingAssociatedCtnAccountSuccess(data));
    dispatch(openSuccessPopup({
      message: 'settings.numberManagement.dataIsChanged',
      messageAsTranslationKey: true,
      keepPreviousPopupOpened: false,
    }));
  };
}

export function handleUpdatingAssociatedBanAccountSuccess(data) {
  return {
    data,
    type: UPDATE_ASSOCIATED_BAN_ACCOUNT_SUCCESS,
  };
}

export function updateAssociatedBanAccountSuccess(data) {
  return (dispatch) => {
    dispatch(handleUpdatingAssociatedBanAccountSuccess(data));
    dispatch(openSuccessPopup({
      message: 'settings.numberManagement.dataIsChanged',
      messageAsTranslationKey: true,
      keepPreviousPopupOpened: false,
    }));
  };
}

export function handleUpdatingAssociatedBenAccountSuccess(data) {
  return {
    data,
    type: UPDATE_ASSOCIATED_BEN_ACCOUNT_SUCCESS,
  };
}

export function updateAssociatedBenAccountSuccess(data) {
  return (dispatch) => {
    dispatch(handleUpdatingAssociatedBenAccountSuccess(data));
    dispatch(openSuccessPopup({
      message: 'settings.numberManagement.dataIsChanged',
      messageAsTranslationKey: true,
      keepPreviousPopupOpened: false,
    }));
  };
}

export function toggleAccountEditPopup(isOpened) {
  return isOpened
    ? openPopup(ACCOUNT_EDIT_POPUP_KEY)
    : closePopup();
}

export function toggleAccountGroupEditPopup(isOpened) {
  return isOpened
    ? openPopup(ACCOUNT_GROUP_EDIT_POPUP_KEY)
    : closePopup();
}

export function toggleContractEditPopup(isOpened) {
  return isOpened
    ? openPopup(CONTRACT_EDIT_POPUP_KEY)
    : closePopup();
}

export function toggleAssociateAccountPopup(isOpened) {
  return isOpened
    ? openPopup(ASSOCIATE_ACCOUNT_POPUP_KEY)
    : closePopup();
}

export function toggleAssociateMasterAccountPopup(isOpened) {
  return isOpened
    ? openPopup(ASSOCIATE_MASTER_ACCOUNT_POPUP_KEY)
    : closePopup();
}

export function toggleConfirmationDeletingPopup(isOpened) {
  return isOpened
    ? openPopup(CONFIRMATION_DELETING_POPUP_KEY)
    : closePopup();
}

export function toggleConfirmationMasterDeletingPopup(isOpened) {
  return isOpened
    ? openPopup(CONFIRMATION_MASTER_DELETING_POPUP_KEY)
    : closePopup();
}

export function fetchMasterAccounts() {
  return async (dispatch) => {
    dispatch(fetchMasterAccountsStart());

    try {
      const { data: { data, error } } = await axios.get('/api/profile/settings/sso/masteraccounts/');

      if (error) {
        dispatch(fetchMasterAccountsError(error));
      } else {
        dispatch(fetchMasterAccountsSuccess(data));
      }
    } catch (error) {
      dispatch(fetchMasterAccountsError(error.message));
    }
  };
}

export function checkMasterAccountsProhibition() {
  return async (dispatch) => {
    dispatch(checkMasterAccountsProhibitionStart());

    try {
      const { data: { isSuccess, errorMessage, enabled } } = await axios
        .get('/api/profile/settings/sso/requesttolinkenabled/');

      if (isSuccess) {
        dispatch(checkMasterAccountsProhibitionSuccess(enabled));
      } else {
        dispatch(checkMasterAccountsProhibitionError(errorMessage));
      }
    } catch (error) {
      dispatch(checkMasterAccountsProhibitionError(error.message));
    }
  };
}

export function updateMasterAccountsProhibition(enabled) {
  return async (dispatch) => {
    dispatch(updateMasterAccountsProhibitionStart());

    try {
      await axios.post('/api/profile/settings/sso/requesttolinkenabled/', { enabled });

      dispatch(updateMasterAccountsProhibitionSuccess(enabled));
    } catch (error) {
      dispatch(updateMasterAccountsProhibitionError(error.message));
    }
  };
}

export function fetchAssociatedAccounts() {
  return async (dispatch) => {
    dispatch(fetchAssociatedAccountsStart());

    try {
      const { data } = await axios.get('/api/profile/settings/sso/associatedaccountlist/');

      dispatch(fetchAssociatedAccountsSuccess(data));
    } catch (error) {
      dispatch(fetchAssociatedAccountsError(error.message));
    }
  };
}

export function deleteAccountLink(linkedLogin) {
  return async (dispatch) => {
    dispatch(deleteAccountLinkStart());

    try {
      const { data: { isSuccess, errorMessage } } = await axios
        .post('/api/profile/settings/sso/delchildaccountlink/', { linkedLogin });

      if (isSuccess) {
        dispatch(deleteAccountLinkSuccess(linkedLogin));
      } else {
        dispatch(deleteAccountLinkError(errorMessage));
      }
    } catch (error) {
      dispatch(deleteAccountLinkError(error.message));
    }
  };
}

export function deleteMasterAccountLink(login) {
  return async (dispatch) => {
    dispatch(deleteMasterAccountLinkStart());

    try {
      const { data: { isSuccess, errorMessage } } = await axios
        .post('/api/profile/settings/sso/delmasteraccountlink/', { login });

      if (isSuccess) {
        dispatch(deleteMasterAccountLinkSuccess(login));
      } else {
        dispatch(deleteMasterAccountLinkError(errorMessage));
      }
    } catch (error) {
      dispatch(deleteMasterAccountLinkError(error.message));
    }
  };
}

export function fetchLinkageRequests() {
  return async (dispatch) => {
    dispatch(fetchLinkageRequestsStart());

    try {
      const [
        { data: { error: incomingError, data: incomingLinkageRequests } },
        { data: { error: outgoingError, data: outgoingLinkageRequests } },
      ] = await Promise.all([
        getLinkageRequests(REQUESTS_TYPES.INVITE, REQUESTS_DURATIONS.IN),
        getLinkageRequests(REQUESTS_TYPES.REQUEST, REQUESTS_DURATIONS.OUT),
      ]);

      if (incomingError || outgoingError) {
        dispatch(fetchLinkageRequestsError(incomingError || outgoingError));
      } else {
        dispatch(fetchLinkageRequestsSuccess({
          incomingLinkageRequests,
          outgoingLinkageRequests,
        }));
      }
    } catch (error) {
      dispatch(fetchLinkageRequestsError(error.message));
    }
  };
}

export function fetchLinkageRequestsForMaster() {
  return async (dispatch) => {
    dispatch(fetchLinkageRequestsForMasterStart());

    try {
      const [
        { data: { error: incomingError, data: incomingLinkageRequestsForMaster } },
        { data: { error: outgoingError, data: outgoingLinkageRequestsForMaster } },
      ] = await Promise.all([
        getLinkageRequests(REQUESTS_TYPES.REQUEST, REQUESTS_DURATIONS.IN),
        getLinkageRequests(REQUESTS_TYPES.INVITE, REQUESTS_DURATIONS.OUT),
      ]);

      if (incomingError || outgoingError) {
        dispatch(fetchLinkageRequestsForMasterError(incomingError || outgoingError));
      } else {
        dispatch(fetchLinkageRequestsForMasterSuccess({
          incomingLinkageRequestsForMaster,
          outgoingLinkageRequestsForMaster,
        }));
      }
    } catch (error) {
      dispatch(fetchLinkageRequestsForMasterError(error.message));
    }
  };
}

export function fetchLoginUserTypes(login) {
  return async (dispatch) => {
    dispatch(fetchLoginUserTypesStart());

    try {
      const { data: { data, error } } = await axios.get('/api/profile/settings/sso/loginusertypes/', {
        params: { login },
      });

      if (error) {
        dispatch(fetchLoginUserTypesError(error));
      } else {
        dispatch(fetchLoginUserTypesSuccess(data));
      }
    } catch (error) {
      dispatch(fetchLoginUserTypesError(error.message));
    }
  };
}

export function createMasterAccountLink({ userLogin, userType }) {
  return async (dispatch) => {
    dispatch(resetLoginUserTypes());
    dispatch(createAccountLinkStart());

    try {
      const { data: { isSuccess, errorMessage } } = await axios
        .post('/api/profile/settings/sso/createaccountlink/', {
          userType,
          linkedLogin: formatLogin(userLogin),
          requestType: REQUESTS_TYPES.INVITE,
        });

      if (isSuccess) {
        await dispatch(fetchLinkageRequestsForMaster());

        dispatch(sendAccountLinkRequestSuccess());
      } else {
        if (errorMessage === AMBIGUOUS_USER_TYPE_ERROR) {
          await dispatch(fetchLoginUserTypes(userLogin));
        }

        dispatch(createAccountLinkError(errorMessage));
      }
    } catch (error) {
      dispatch(createAccountLinkError(error.message));
    }
  };
}

export function createAccountLinkWithPassword({
  userLogin,
  userPassword,
  userType,
}) {
  return async (dispatch) => {
    dispatch(createAccountLinkStart());

    try {
      const { data: { isSuccess, errorMessage } } = await axios
        .post('/api/profile/settings/sso/createlinkagebyloginandpassword/', {
          userType,
          linkedAccountLogin: userLogin,
          linkedAccountPassword: userPassword,
        });

      if (isSuccess) {
        await dispatch(fetchAssociatedAccounts());

        dispatch(createAccountLinkSuccess());
      } else {
        if (errorMessage === AMBIGUOUS_USER_TYPE_ERROR) {
          await dispatch(fetchLoginUserTypes(userLogin));
        }

        dispatch(createAccountLinkError(errorMessage));
      }
    } catch (error) {
      dispatch(createAccountLinkError(error.message));
    }
  };
}

export function createAccountLinkWithoutPassword({ userLogin, userType }) {
  return async (dispatch) => {
    dispatch(createAccountLinkStart());

    try {
      const { data: { isSuccess, errorMessage } } = await axios
        .post('/api/profile/settings/sso/createaccountlink/', {
          userType,
          linkedLogin: formatLogin(userLogin),
          requestType: REQUESTS_TYPES.REQUEST,
        });

      if (isSuccess) {
        await dispatch(fetchLinkageRequests());

        dispatch(sendAccountLinkRequestSuccess());
      } else {
        if (errorMessage === AMBIGUOUS_USER_TYPE_ERROR) {
          await dispatch(fetchLoginUserTypes(userLogin));
        }

        dispatch(createAccountLinkError(errorMessage));
      }
    } catch (error) {
      dispatch(createAccountLinkError(error.message));
    }
  };
}

export function createAccountLink(data) {
  return async (dispatch) => {
    dispatch(resetLoginUserTypes());

    if (data.isPasswordAvailable) {
      dispatch(createAccountLinkWithPassword(data));
    } else {
      dispatch(createAccountLinkWithoutPassword(data));
    }
  };
}

export function handleCloseAssociateAccountPopup() {
  return (dispatch) => {
    dispatch(toggleAssociateAccountPopup(false));
    dispatch(resetAccountLinkingStatus());
    dispatch(resetLoginUserTypes());
  };
}

export function handleCloseAssociateMasterAccountPopup() {
  return (dispatch) => {
    dispatch(toggleAssociateMasterAccountPopup(false));
    dispatch(resetAccountLinkingStatus());
    dispatch(resetLoginUserTypes());
  };
}

export function cancelLinkageRequest(login) {
  return async (dispatch) => {
    dispatch(cancelLinkageRequestStart(login));

    try {
      const { data: { isSuccess, errorMessage } } = await axios
        .post('/api/profile/settings/sso/cancellinkagerequest/', {
          linkedLogin: login,
          requestType: REQUESTS_TYPES.REQUEST,
        });

      if (isSuccess) {
        dispatch(cancelLinkageRequestSuccess(login));
        dispatch(handleCloseAssociateAccountPopup());
      } else {
        dispatch(cancelLinkageRequestError(errorMessage));
      }
    } catch (error) {
      dispatch(cancelLinkageRequestError(error.message));
    }
  };
}

export function cancelLinkageRequestForMaster(login) {
  return async (dispatch) => {
    dispatch(cancelLinkageRequestForMasterStart(login));

    try {
      const { data: { isSuccess, errorMessage } } = await axios
        .post('/api/profile/settings/sso/cancellinkagerequest/', {
          linkedLogin: login,
          requestType: REQUESTS_TYPES.INVITE,
        });

      if (isSuccess) {
        dispatch(cancelLinkageRequestForMasterSuccess(login));
        dispatch(handleCloseAssociateMasterAccountPopup());
      } else {
        dispatch(cancelLinkageRequestError(errorMessage));
      }
    } catch (error) {
      dispatch(cancelLinkageRequestError(error.message));
    }
  };
}

export function updateLinkageRequest(data) {
  return async (dispatch) => {
    dispatch(updateLinkageRequestStart(data.linkedLogin));

    try {
      const { data: { isSuccess, errorMessage } } = await axios
        .post('/api/profile/settings/sso/updatelinkagerequest/', data);

      if (isSuccess) {
        if (data.accepted) {
          await dispatch(fetchAssociatedAccounts());
        }

        dispatch(updateLinkageRequestSuccess(data.linkedLogin));
      } else {
        dispatch(updateLinkageRequestError(errorMessage));
      }
    } catch (error) {
      dispatch(updateLinkageRequestError(error.message));
    }
  };
}

export function updateLinkageRequestForMaster(data) {
  return async (dispatch) => {
    dispatch(updateLinkageRequestForMasterStart(data.linkedLogin));

    try {
      const { data: { isSuccess, errorMessage } } = await axios
        .post('/api/profile/settings/sso/updatelinkagerequest/', data);

      if (isSuccess) {
        if (data.accepted) {
          await dispatch(fetchMasterAccounts());
        }

        dispatch(updateLinkageRequestForMasterSuccess(data.linkedLogin));
      } else {
        dispatch(updateLinkageRequestError(errorMessage));
      }
    } catch (error) {
      dispatch(updateLinkageRequestError(error.message));
    }
  };
}

export function fetchOffer() {
  return async (dispatch) => {
    dispatch(fetchOfferStart());

    try {
      const { data: { offerText } } = await axios
        .get('/api/profile/settings/offer/', {
          params: {
            offerType: OFFER_TYPE,
            offerText: true,
          },
        });

      dispatch(fetchOfferSuccess(offerText));
    } catch (error) {
      dispatch(fetchOfferError(error.message));
    }
  };
}

export function updateAssociatedCtnAccount({
  isMobile,
  nickName,
  banLogin,
  postpaidLimit,
  linkedAccountLogin,
  isDefaultSsoLogin,
}) {
  return async (dispatch) => {
    dispatch(updateAssociatedAccountStart());

    try {
      const { data: { isSuccess, errorMessage } } = isMobile
        ? await updateCtnAccount({
          nickName,
          banLogin,
          postpaidLimit,
          linkedAccountLogin,
          isDefaultSsoLogin,
        })
        : await axios.post('/api/profile/settings/sso/associatedfttbaccount/', {
          nickName,
          linkedAccountLogin,
          isDefaultSsoLogin,
        });

      if (isSuccess) {
        dispatch(updateAssociatedCtnAccountSuccess({
          nickName,
          postpaidLimit,
          linkedAccountLogin,
          isDefaultSsoLogin,
        }));
      } else {
        dispatch(updateAssociatedAccountError(errorMessage));
      }
    } catch (error) {
      dispatch(updateAssociatedAccountError(error.message));
    }
  };
}

export function updateAssociatedBanAccount(data) {
  return async (dispatch) => {
    dispatch(updateAssociatedAccountStart());

    try {
      const { data: { isSuccess, errorMessage } } = await axios
        .post('/api/profile/settings/sso/associatedbanaccount/', data);

      if (isSuccess) {
        dispatch(updateAssociatedBanAccountSuccess(data));
      } else {
        dispatch(updateAssociatedAccountError(errorMessage));
      }
    } catch (error) {
      dispatch(updateAssociatedAccountError(error.message));
    }
  };
}

export function updateAssociatedBenAccount(data) {
  return async (dispatch) => {
    dispatch(updateAssociatedAccountStart());

    try {
      const { data: { isSuccess, errorMessage } } = await axios
        .post('/api/profile/settings/sso/associatedbenaccount/', data);

      if (isSuccess) {
        dispatch(updateAssociatedBenAccountSuccess(data));
      } else {
        dispatch(updateAssociatedAccountError(errorMessage));
      }
    } catch (error) {
      dispatch(updateAssociatedAccountError(error.message));
    }
  };
}

export function fetchPinPuk() {
  return async (dispatch) => {
    dispatch(fetchPinPukStart());

    try {
      const { data } = await axios.get('/api/profile/settings/pinPuk/');

      if (data) {
        dispatch(fetchPinPukSuccess(data));
      } else {
        dispatch(fetchPinPukError('Data is empty'));
      }
    } catch (error) {
      dispatch(fetchPinPukError(error.message));
    }
  };
}

export function fetchAssociatedAccountsData() {
  return (dispatch) => {
    dispatch(resetAssociatedAccountsError());
    dispatch(fetchAssociatedAccounts());
    dispatch(fetchLinkageRequests());
    dispatch(fetchOffer());
  };
}

export function fetchMasterAccountsData() {
  return (dispatch) => {
    dispatch(resetMasterAccountsError());
    dispatch(fetchMasterAccounts());
    dispatch(checkMasterAccountsProhibition());
    dispatch(fetchLinkageRequestsForMaster());
  };
}

export function fetchInitialData() {
  return (dispatch) => {
    dispatch(fetchAssociatedAccountsData());
    dispatch(fetchMasterAccountsData());
  };
}
